<template>
  <section class="c-section c-section--login py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-7">
          <div class="bg-white br--medium p-4 py-5 d-flex flex-column align-items-center">
            <b-spinner variant="primary"></b-spinner>
            <h1 class="fs-21 w-bold mt-3 darks">
              {{ (operationType === 'verify') ? 'Verificando acceso' : 'Procesando inscripción' }}
            </h1>

            <div
              v-if="alert"
              class="c-card-alert p-2 px-3 text-center mt-4"
              :class="`c-card-alert--${alert.type}`"
            >
              {{alert.message}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { enrollAtCourse } from '../libs/course';

export default {
  data() {
    return {
      alert: null,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    operationType() {
      return this.$route.query.verify && Number(this.$route.query.verify) === 1
        ? 'verify'
        : 'enroll';
    },
  },
  mounted() {
    if (this.operationType === 'verify') {
      this.checkEnrollment();
    } else {
      this.makeEnrollment('free');
    }
  },
  methods: {
    enrollAtCourse,
    checkEnrollment() {
      const courseId = this.$route.params.course_id;
      const url = `${process.env.VUE_APP_SITE}/api/v1/courses/${courseId}/students/${(this.userData && this.userData.id)}/next`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            this.alert = {
              type: 'success',
              message: 'Acceso autorizado 🥳 (redirigiendo al curso en 3..2..1)',
            };

            window.setTimeout(() => {
              window.location.href = response.data.url;
            }, 3000);
          } else {
            this.alert = {
              type: 'error',
              message: 'Lo sentimos 😢, no tienes acceso al curso (regresando en 3..2..1)',
            };

            window.setTimeout(() => {
              window.location.href = '/es/cursos/etiqueta/gratis';
            }, 3000);
          }
        });
    },
    async makeEnrollment(plan = null) {
      const courseId = this.$route.params.course_id;

      try {
        const response = await this.enrollAtCourse(courseId, plan);

        this.alert = {
          type: 'success',
          message: 'Inscripción exitosa 🥳 (redirigiendo al curso en 3..2..1)',
        };

        if (response.data.next_lection) {
          window.location.href = response.data.next_lection.url;
        } else {
          window.location.href = response.data.url;
        }
      } catch (error) {
        let errorMessage = '';

        try {
          errorMessage = JSON.parse(error.message)?.message;
        } catch (err) {
          errorMessage = error.message;
        }

        this.alert = {
          type: 'error',
          message: errorMessage.message,
        };

        window.setTimeout(() => {
          window.location.href = `${errorMessage.url}`;
        }, 3000);
      }
    },
  },
};
</script>
